











import {Component, Vue} from 'vue-property-decorator';
import {Action, Getter} from 'vuex-class';
import FileHandle from '@/components/FileHandle.vue';
import DetectModerationCard from './Card.vue';


const namespace: string = 'moderationDetect';

@Component({
    components : {
        FileHandle,
        DetectModerationCard
    }
})
export default class Moderation extends Vue {
    @Action('s3Upload', {namespace}) s3Upload : any;
    @Action('getDB', {namespace}) getDB : any;
    @Getter('getItems', {namespace}) getItems : any;


    private created() {
        this.getDB()
    }
    private file : any = null;


    uploadFile(file : any) : void {
        this.s3Upload(file)

    }


}
